import classnames from "classnames";
import { HeaderGroup as HeaderGroupType } from "react-table";
import { genericMemo } from "../../../../../../utils/genericMemo";
import { Column } from "../../../TableContainer";
import FilterContext from "../contexts/FilterContext";
import SortingContext from "../contexts/SortingContext";
import SortComponent from "./SortComponent";

import styles from "../style.module.scss";

type HeaderCellProps<T extends object> = {
  column: HeaderGroupType<T>,
  style?: object,
};

const HeaderCell = genericMemo(
  <T extends object>({ column, ...restProps }: HeaderCellProps<T>) => {
    const { style, onClick } = column.getSortByToggleProps() as any;
    let headerTitle = column.render("Header");
    let title = (!column.disableSortBy && column.canSort) ? "Toggle sorting" : undefined;
    if (typeof headerTitle === "string") {
      title = headerTitle;
      headerTitle = <div className={styles.title}>
        {headerTitle}
      </div>;
    }

    const declaredColumn = (column as Column<T>);
    const declaredCellProps = declaredColumn?.getCellProps?.(undefined, "header");

    return (
      <div
        {...restProps}
        {...declaredCellProps}
        className={
          classnames(
            styles.headerBlock,
            styles.cell,
            styles.headerCell,
            { [styles.selectionCell]: (column as Column<T>).freezeOnScroll },
            declaredCellProps?.className,
          )
        }
      >
        <div className={styles.titleBlock} style={style} title={title} onClick={onClick}>
          {headerTitle}
          <SortingContext.Consumer>
            {
              () =>
                <SortComponent
                  className={styles.sortIcon}
                  canSort={column.canSort}
                  isSorted={column.isSorted}
                  isSortedDesc={column.isSortedDesc}
                />
            }
          </SortingContext.Consumer>
        </div>
        {
          (!column.disableFilters && column.Filter) && (
            <FilterContext.Consumer>
              {() => (
                <div className={styles.filter}>
                  {column.render("Filter")}
                </div>
              )}
            </FilterContext.Consumer>
          )
        }
        {column.canResize && (
          <div
            {...column.getResizerProps()}
            className={styles.resizer}
          />
        )}
      </div>
    );
  },
);

export default HeaderCell;
